import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Link } from "react-router-dom";

function formatCropYearLabel(cropYear) {
  const year = cropYear?.crop_year || "Draft";
  const crop = cropYear?.crop_this_year?.replaceAll("_", " ");

  return crop ? `${year} ${crop}` : `${year} Crop Year`;
}

function buildFarmBreadcrumb({ farm, farmId, includeDashboard = false }) {
  const items = [];

  if (includeDashboard) {
    items.push({
      label: "Dashboard",
      to: "/dashboard",
    });
  }

  if (farmId) {
    items.push({
      label: farm?.name || "Farm",
      to: `/farm/${farmId}`,
    });
  }

  return items;
}

function buildFieldBreadcrumb({ farm, field, farmId, fieldId, includeDashboard = false }) {
  return [
    ...buildFarmBreadcrumb({ farm, farmId, includeDashboard }),
    ...(farmId && fieldId
      ? [
          {
            label: field?.name || "Field",
            to: `/farm/${farmId}/field/${fieldId}`,
          },
        ]
      : []),
  ];
}

function buildCropYearBreadcrumb({
  farm,
  field,
  cropYear,
  farmId,
  fieldId,
  cropyearId,
  includeDashboard = false,
}) {
  return [
    ...buildFieldBreadcrumb({ farm, field, farmId, fieldId, includeDashboard }),
    ...(farmId && fieldId && cropyearId
      ? [
          {
            label: formatCropYearLabel(cropYear),
            to: `/farm/${farmId}/field/${fieldId}/cropyear/${cropyearId}/rotation`,
          },
        ]
      : []),
  ];
}

function ResourceBreadcrumb({ ariaLabel = "Location", items = [] }) {
  const visibleItems = items.filter((item) => item?.to && item?.label);

  if (!visibleItems.length) {
    return null;
  }

  return (
    <nav
      aria-label={ariaLabel}
      className="mb-3 overflow-x-auto border-b border-slate-200 bg-transparent px-1 pb-2 pt-1"
    >
      <ol className="flex min-w-max items-center gap-1 whitespace-nowrap text-sm md:min-w-0 md:flex-wrap">
        {visibleItems.map((item, index) => {
          const isCurrent = index === visibleItems.length - 1;

          return (
            <li key={item.to} className="flex shrink-0 items-center md:min-w-0 md:shrink">
              {index > 0 ? (
                <ChevronRightIcon
                  aria-hidden="true"
                  className="mx-1 shrink-0 text-slate-400"
                  fontSize="small"
                />
              ) : null}
              <Link
                aria-current={isCurrent ? "page" : undefined}
                className={`max-w-[220px] truncate rounded-[6px] px-2 py-1 font-semibold transition-colors hover:bg-slate-100 hover:text-[#2f6f45] focus:outline-none focus:ring-2 focus:ring-[#34a853]/35 md:max-w-[320px] ${
                  isCurrent ? "text-[#2f6f45]" : "text-slate-600"
                }`}
                title={item.label}
                to={item.to}
              >
                {item.label}
              </Link>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export {
  ResourceBreadcrumb,
  buildCropYearBreadcrumb,
  buildFarmBreadcrumb,
  buildFieldBreadcrumb,
  formatCropYearLabel,
};
